<div>
  @if (isInfrastructureDelegate()) {
    <overflow-menu-button [enabled]="selfServiceEnabled()">
      @if (isIpBgp()) {
        <div
          class="overflow-menu__item"
          (click)="selectItem('bgp')"
          [matTooltip]="'Selfservice.Tooltip.BGP' | translate"
          [matTooltipPosition]="'above'"
        >
          {{ "OverflowMenu.ModifyBGP" | translate }}
        </div>
      }
      <div
        class="overflow-menu__item"
        [matTooltip]="'Selfservice.Tooltip.IPPrefixes' | translate"
        [matTooltipPosition]="'above'"
        (click)="selectItem('ip-prefixes')"
      >
        {{ "OverflowMenu.ModifyIPP" | translate }}
      </div>
    </overflow-menu-button>
  }
</div>
